<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-06 10:44:20
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-12-22 16:21:15
-->
<template>
  <div class="list-wrapper">
    <van-sticky>
      <div class="list-top" v-if="activeTab === 0">
        <van-search
          v-model="keyword"
          @input="handleSearch()"
          @search="handleSearch()"
          shape="round"
          placeholder="请输入搜索关键词"
          style="flex:1" />
          <div @click="handleSign" class="sign" v-if="activeTab === 0">
            <van-icon name="notes-o" size="30" color="#4290f7" />
            <span :style="userInfo.isCheckIn ? {color: '#909399'} : {color:'#4290f7'}">
              {{ userInfo.isCheckIn ? '已签' : '签到' }}
            </span>
          </div>
          <!-- <div v-else class="sub" :issub="bbsSubInfo.isSub" @click="() => bbsSubscribe()">
            <van-icon v-if="bbsSubInfo.isSub" name="success" size="14" color="#909399" />
            <img v-else src="../../assets/xinhao.png" style="width: 12px; height: 12px"/>
            <span :style="bbsSubInfo.isSub ? {color: '#909399', marginLeft: '4px'} : {color:'#ffffff', marginLeft: '4px'}">
              {{ bbsSubInfo.isSub ? '已订阅' : '订阅' }} <span v-if="bbsSubInfo.subNum">&nbsp;{{bbsSubInfo.subNum}}</span>
            </span>
          </div> -->
      </div>
      <van-tabs
        v-if="!keyword && (activeTab === 0)"
        v-model="active"
        @click="handleTabChange"
        title-active-color="#ee0a24"
        style="position:relative;top:-1px;"
        >
        <van-tab
          v-for="item in tabList"
          :key="item.id"
          :name="item.id"
        >
          <template #title>{{item.name}}<van-icon v-if="item.id === -1" name="fire" color="#ee0a24" style="margin-left: 4px"/></template>
        </van-tab>
        
      </van-tabs>
      <div v-else-if="activeTab === 1">
        <van-tabs
          v-if="deptList.length"
          v-model="deptActive"
          @change="() => handleTabChange(false)"
          title-active-color="#ee0a24"
          class="bbs-tabs"
          style="position:relative;top:-1px;"
          >
          <van-tab
            v-for="item in deptList"
            :key="item.orgCode"
            :name="item.orgCode"
            >
            <!-- :title="item.deptName" -->
             <template #title> 
              <span v-if="item.orgCode === -1 || sourceDeptList.length === 1">{{item.deptName}} </span>
              <!-- <van-dropdown-menu v-else v-model="selectDeptOrgCode">
                <van-dropdown-item :options="item.list" />
              </van-dropdown-menu> -->
              <!-- <van-dropdown-menu v-else :is-active="`${deptActive === -2}`">
                <van-dropdown-item :title="selectDept.deptName || '部门'" ref="dropdown-menu">
                  <div class="dropdown-list">
                    <div
                      class="dropdown-item"
                      v-for="(_item, index) in item.list"
                      @click="handleSelectDept(_item)"
                      :is-active="`${_item.orgCode === selectDeptOrgCode}`"
                      :key="_item.orgCode + index">{{_item.deptName}}</div>
                  </div>
                </van-dropdown-item>
              </van-dropdown-menu> -->
                
                <van-popover v-else v-model="showPopover" placement="bottom-end">
                  <div class="dropdown-list">
                    <div
                      class="dropdown-item"
                      v-for="(_item, index) in item.list"
                      @click="handleSelectDept(_item)"
                      :is-active="`${_item.orgCode === selectDeptOrgCode}`"
                      :key="_item.orgCode + index">{{_item.deptName}}</div>
                  </div>
                  <template #reference>
                    <div @click="handleShowPopover" class="dept-name-wrap">
                      <span class='dept-name'>{{selectDept.deptName || '部门'}}</span>
                      <van-icon v-if="!showPopover" name="arrow-down" style="margin-left: 8px"/>
                      <van-icon v-else name="arrow-up"  style="margin-left: 8px" />
                    </div>
                  </template>
                </van-popover>
              </template>
            </van-tab>
        </van-tabs>
        <div class="type-select-wrap">
          <div class="type-select-left">
            <div
              class="type-item"
              v-for="item in bbsTypeList"
              :key="item.id"
              :active="+item.id === +active"
              @click="() => selectBbsTypeActive(item.id)"
            >{{item.name}}</div>
          </div>
            <!-- <div class="sub" :issub="bbsSubInfo.isSub" @click="() => bbsSubscribe()">
              <van-icon v-if="bbsSubInfo.isSub" name="success" size="14" color="#909399" />
              <img v-else src="../../assets/xinhao.png" style="width: 12px; height: 12px"/>
              <span :style="bbsSubInfo.isSub ? {color: '#909399', marginLeft: '4px'} : {color:'#ffffff', marginLeft: '4px'}">
                {{ bbsSubInfo.isSub ? '已订阅' : '订阅' }} <span v-if="bbsSubInfo.subNum">&nbsp;{{bbsSubInfo.subNum}}</span>
              </span>
            </div> -->
          <div class="type-operate">
            <div class="operate-item">
              <!-- <van-badge class="sub-badge"  v-if="bbsSubInfo.isSub"  :content="bbsSubInfo.subNum" color="#bfbfbf"> -->
                <img v-if="bbsSubInfo.isSub" src="../../assets/sub-success.png" style="width: 15px; height: 14px" @click="() => bbsSubscribe()"/>
              <!-- </van-badge> -->
              <img v-else src="../../assets/sub.png" style="width: 15px; height: 14px" @click="() => bbsSubscribe()"/>
              <span>{{bbsSubInfo.isSub ? `已订(${bbsSubInfo.subNum})` : '订阅'}}</span>
            </div>
            <div class="operate-item">
              <img style="width: 15px;height: 14px" src="../../assets/share.png" @click="handleShare"/>
              <span>分享</span>
            </div>
          </div>
        </div>
      </div>
    </van-sticky>
    <div>
      <div v-if="!keyword && activeTab === 0" class="swipe-out">
        <div class="swipe-wrapper">
          <span class="swipe-top">【置顶】</span>
          <van-swipe :show-indicators="false" :autoplay="3000" vertical class="swipe">
            <van-swipe-item
              v-for="item in bannerList"
              :key="item.id"
              @click="handleLinkTop(item)"
              class="swipe-item">
              {{item.title}}
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <van-pull-refresh
        v-if="articleList.length || loading"
        v-model="refreshing"
        @refresh="onRefresh"
        success-text="刷新成功">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          style="margin-top:10px;padding-bottom:50px;"
        >
        <div
          v-for="item in articleList"
          :key="item.id"
        >
          <card
            v-if="item.type === 0"
            :showDeptSource="+activeTab === 1 && +deptActive === -1"
            @refresh="handleRefresh"
            :timeField="(activeTab === 1 && active === 2) ? 'createTime' : 'changeTime'"
            :rowData="item" />
          <BbsCard
            v-else
            :showDeptSource="+activeTab === 1 && +deptActive === -1"
            @refresh="handleRefresh"
            :timeField="(activeTab === 1 && active === 2) ? 'createTime' : 'changeTime'"
            :rowData="item" />
        </div>
        </van-list>
      </van-pull-refresh>
      <van-empty v-else :description="activeTab === 1 && deptActive > -1 ? '部门内暂无人发言，快来一起交流吧！' : '未搜索到相关信息！'" />
      
    </div>
    <Footer @tabChange="handleBottomTabChange" :activeTab="activeTab" :deptActive="deptActive === -2 ? selectDeptOrgCode : deptActive"/>
  </div>
</template>

<script>
import Card from './components/card.vue'
import api from '../../api'
import { throttle, debounce } from '../../utils/lib'
import Footer from '../../components/footer.vue'
import { mapState, mapActions } from 'vuex';
import BbsCard from './components/bbsCard.vue';

export default {
  components: {
    Card,
    Footer,
    BbsCard
  },
  data() {
    return {
      active: 1,
      activeTab: +this.$route.query?.type || 0,
      tabList: [],
      articleList: [],
      bannerList: [],
      loading: false,
      finished: false,
      refreshing: false,
      jszxOrgCode: '00024935',
      jszxDeptName: '京东集团-京东零售-平台产品与技术研发中心',
      categoryId: 0,
      pageParams: {
        page: 1,
        pageSize: 10
      },
      deptActive: this.$route.query?.orgCode || -1,
      searchPageParams: {
        page: 1,
        pageSize: 20
      },
      keyword: '',
      deptList: [],
      selectDeptOrgCode: '',
      // selectDept: {},
      sourceDeptList: [],
      bbsTypeList: [
        { id: 1, name: '最新回复' },
        { id: 2, name: '最新发布' },
        { id: 3, name: '热门畅聊' },
      ],
      showPopover: false,
    }
  },
  created() {
    if (+this.$route.query?.type === 1) {
      this.fetchDeptList(true);
    } else {
      const id = this.$route.query.id;
      this.fetchCategoryList(+id).then(() => {
        this.fetchList();
        this.bbsSubscribe(0);
      })
    }
    
    this.fetchBannerList();
    this.handleBack();
  },
  activated() {
    this.handleBack()
    // if (!this.keyword) {
    //   this.pageParams.page++
    //   this.fetchList()
    // } else {
    //   this.searchPageParams.page++
    //   this.fetchSearchList()
    // }
  },
  computed: {
    ...mapState(['userInfo', 'bbsSubInfo']),
    listApi() {
      switch(this.active) {
        case 1:
          if (this.activeTab === 1) {
            return api.getNewList
          }
          return api.getHotList
        case 2:
          return api.getNewList
        case 3:
          if (this.activeTab === 1) {
            return api.getHotList
          }
          return api.getFocusList
        default:
          return api.getCategoryList
      }
    },
    selectDept() {
      const selectDept = this.sourceDeptList?.find((item) => item.orgCode === this.selectDeptOrgCode);
      return selectDept || {};
    },
    // bbsTabList() {
    //   return [
    //     {
    //       orgCode: -1,
    //       deptName: '社区'
    //     },
    //     ...this.deptList
    //   ]
    // },
    // activeTab() {
    //   return +this.$route.query?.type || 0
    // }
  },
  methods: {
    ...mapActions(['updateUserInfo', 'updateUserInfoList', 'updateBbsSubInfo']),
    selectBbsTypeActive(type) {
      this.active = type;
      this.handleTabChange();
    },
    handleShowPopover() {
      if (this.deptActive === -1) return;
      this.showPopover = !this.showPopover;
    },
    handleSelectDept(dept) {
      this.selectDeptOrgCode = dept.orgCode;
      this.handleTabChange(false);
      this.showPopover = !this.showPopover;
      
    },
    async fetchDeptList(_init = false) {
      if (this.activeTab === 1) {
        const { code, data } = await api.getDept();
        if (code === 200) {
          const deptList = data.map((item) => {
            const nameList = item.name.split('-');
            return {
              ...item,
              deptName: item.name === '集团T-PaaS' ? item.name : nameList[nameList.length - 1],
              text: item.name === '集团T-PaaS' ? item.name : nameList[nameList.length - 1],
              value: item.orgCode
            }
          }) ;
          this.sourceDeptList = deptList;
          let orgCode = deptList[0]?.orgCode;
          const jszx = deptList?.find((item) => item.orgCode === this.jszxOrgCode);
          if (jszx && this.userInfo.department?.startsWith(this.jszxDeptName)) {
            orgCode = this.jszxOrgCode;
          }
          if (deptList?.length === 1) {
            this.deptList = [{
              orgCode: -1,
              deptName: '社区'
            }, 
              ...deptList,
            ];
            if (jszx && this.userInfo.department?.startsWith(this.jszxDeptName) && _init && !this.$route.query?.orgCode) {
                this.deptActive = orgCode;
              }
          } else if (deptList?.length) {
            this.deptList = [{
              orgCode: -1,
              deptName: '社区'
            }, {
              orgCode: -2,
              deptName: '部门',
              list: [
              ...deptList,
            ]
            }]
            this.selectDeptOrgCode = orgCode;
            if (jszx && this.userInfo.department?.startsWith(this.jszxDeptName) && _init && !this.$route.query?.orgCode) {
                this.deptActive = -2;
              }
          }
          if (_init && this.$route.query?.orgCode && this.$route.query?.orgCode !== '-1' && deptList?.length) {
              const currentDept = deptList.find((item) => item.orgCode === this.$route.query?.orgCode);
              if (!currentDept) {
                this.deptActive = deptList[0]?.orgCode;
              } else {
                this.selectDeptOrgCode = currentDept?.orgCode;
                this.deptActive = deptList?.length > 1 ? -2 : currentDept?.orgCode;
              }
            }
        }
        this.$nextTick(() => {
          this.fetchList();
          this.bbsSubscribe(0);
        })
      }
    },
    handleShare() {
      let url = 'http://sd.jd.com/articleList?type=1&isHideShareButton=1';
      let title = '神灯畅聊';
      let content = '技术议题讨论、意见公开征集、工具平台“吐槽”...尽在神灯畅聊！';

      const currentDept = this.deptList.find((item) => item.orgCode === this.deptActive);
      if (currentDept && +this.deptActive !== -1) {
        let orgCode = currentDept.orgCode;
        let deptName = currentDept.deptName;
        if (orgCode === -2) {
          const _currentDeptItemInfo = currentDept?.list?.find((item) => item.orgCode === this.selectDeptOrgCode)
          orgCode = this.selectDeptOrgCode;
          deptName = _currentDeptItemInfo?.deptName
        }
        url = `${url}&orgCode=${orgCode}`;
        title = `${deptName || ''}畅聊圈`;
        content = '部门专属畅聊圈，快来一起交流吧！'
      }
      const options = {
        shareData: {
          title,
          content,
          url,
          icon: 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-02-28-17-07uAVeSgG0YYEUaxf.png',
        },
        typeList: ['JDMESession', 'CopyLink'],
        callback: function() {
        }
      }
      window.jme.share.shareCustom(options)
    },
    bbsSubscribe(flag = 1) {
      if (+this.activeTab !== 1) return;
      const params = {
        flag
      };
      if (this.deptActive > -1 && this.deptList.find((item) => item.orgCode === this.deptActive)) {
        params.orgCode = this.deptActive;
      }
      if (this.deptActive === -2) {
        params.orgCode = this.selectDeptOrgCode;
      }
      api.bbsSubscribe(params).then((res) => {
        if (res?.code === 200) {
          this.updateBbsSubInfo(res?.data);
          if (res?.data?.isSub && flag) {
            this.$toast(
            {
              message: '订阅成功！新畅聊发布将及时为您发送通知，感谢订阅！',
              type: 'success',
              className: 'toast-sub',
              duration: 5000
            }
          )
          }
        }
      })
    },
    handleBack() {
      const _this = this;
      let options = {
        disabled: true,
        callback: function() {
          if (_this.activeTab === 1) {
              _this.handleBottomTabChange(0)
            } else {
              window.jme.browser.closeWeb()
            }
        }
      }
      window.jme.browser.setGoBackDisabled(options)
    },
    fetchCategoryList(id = 0) {
      return new Promise((resolve) => {
        if (this.activeTab === 1) {
          this.tabList = [
            { id: 1, name: '最新回复' },
            { id: 2, name: '最新发布' },
            { id: 3, name: '热门畅聊' },
            // { id: 3, name: '问答' },
            // { id: 4, name: '投票' },
          ]
          resolve()
          return;
        }
        let type = this.activeTab < 2 ? this.activeTab : 0
        api.getCategory(type).then(res => {
          const { code, data } = res
          if (code === 200) {
            this.tabList = [
              { id: 1, name: '推荐' },
              { id: 2, name: '最新' },
              { id: 3, name: '关注' },
              // { id: -1, name: '黑马大赛' },
              ...data
            ]
            if (id) {
              this.tabList.forEach((item, index) => {
                if (item.id === id) {
                  this.active = index
                }
              })
            }
          }
          resolve()
        })
      })
    },
    fetchBannerList() {
      api.getBannerList(this.activeTab).then(res => {
        const { code, data } = res
        if (code === 200) {
          this.bannerList = data
        }
      })
    },
    fetchList() {
      this.loading = true
      const params = {
        ...this.pageParams,
        fromH5: 1,
      }
      if (this.active > 1) {
        params.categoryId = this.active
      }
      let type = this.activeTab < 2 ? this.activeTab : 0;
      if (this.activeTab === 1) {
        params.typeList = '1,3';
        type = '1,3';
        if (this.deptActive > -1 && this.deptList.find((item) => item.orgCode === this.deptActive)) {
          params.orgCode = this.deptActive;
        }
        if (this.deptActive === -2) {
          params.orgCode = this.selectDeptOrgCode;
        }
      }
      if (this.activeTab === 1 && this.active === 2) {
        params.condition = 1;
      }
      this.listApi(params, type).then(res => {
        this.loading = false
        const { code, data, totalCount } = res
        if (this.refreshing) {
          this.refreshing = false
        }
        if (code === 200) {
          if (this.pageParams.page > 1) {
            this.articleList = this.articleList.concat(data)
          } else {
            this.articleList = data
          }
          const userIds = data?.map((item) => item.userId);
          if (userIds?.length) {
            this.updateUserInfoList(userIds.join())
          }
          if (this.articleList.length >= totalCount) {
            this.finished = true
          }
        }
      })
    },
    fetchSearchList() {
      if (this.keyword) {
        const params = { 
          ...this.searchPageParams,
          keyword: this.keyword,
          duration: 0,
          listType: '0,1',
          listContent: 1,
          listTitle: 1,
          listErp: 1
        }
        this.loading = true
        let type = this.activeTab < 2 ? this.activeTab : 0
        api.getSearchList(params, type).then(res => {
          this.loading = false
          if (this.refreshing) {
            this.refreshing = false
          }
          const { code, data, pageCount } = res
          if (code === 200) {
            if (this.searchPageParams.page > 1) {
              this.articleList = this.articleList.concat(data)
            } else {
              this.articleList = data
            }
            if (this.searchPageParams.page >= pageCount) {
              this.finished = true
            }
            const userIds = data?.map((item) => item.userId);
            if (userIds?.length) {
              this.updateUserInfoList(userIds.join())
            }
          }
        })
      } else {
        this.pageParams.page = 1
        this.fetchList()
      }
    },
    handleSearch: throttle(function() {
      // if (this.keyword === '年度报告') {
      //   this.$router.push({ name: 'yearReport' })
      //   return;
      // }
      this.finished = false
      this.searchPageParams.page = 1
      this.articleList = []
      this.fetchSearchList()
    }, 1000),
    handleTabChange(changeTabType = true) {
      if (this.active === -1) {
        document.body.scrollTop = document.documentElement.scrollTop = 0
        this.$router.push({
          name: 'circleDetail',
          params: {
            id: 73
          }
        })
      }
      this.keyword = ''
      this.finished = false
      this.pageParams.page = 1;
      if (!changeTabType || this.active === -1) {
        this.active = 1;
        this.bbsSubscribe(0);
      }
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.articleList = []
      this.fetchList()
    },
    handleBottomTabChange(val) {
      this.activeTab = val;
      this.pageParams.page = 1;
      this.deptActive = -1;
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.keyword = ''
      this.finished = false
      this.articleList = []
      this.active = 1
      if (val > 1) return;
      this.fetchCategoryList();
      if (val === 1) {
        this.fetchDeptList(true);
      } else {
        this.fetchList();
        this.fetchBannerList()
      }
      
    },
    onRefresh() {
      this.finished = false
      if (this.keyword) {
        this.searchPageParams.page = 1
        this.fetchSearchList()
        return
      }
      this.pageParams.page = 1 
      this.fetchList()
    },
    onLoad() {
      if (this.keyword) {
        this.searchPageParams.page++
        this.fetchSearchList()
        return
      }
      this.pageParams.page++
      this.fetchList()
    },
    handleRefresh(val, type) {
      if (val) {
        if (type === 'vote') {
          this.articleList = this.articleList.map(item => {
          if (item.id === val.id) {
            item = Object.assign(item, {...val})
          }
          return item
        })
          return;
        }
        if (type === 'share') {
          this.articleList = this.articleList.map(item => {
          if (item.id === val.id) {
            item = Object.assign(item, { sharedNum: val.sharedNum })
          }
          return item
        })
          return;
        }
        let up
        let upNum
        if (val.isUp === '踩') {
          up = val.isUp === '踩' ? -1 : 1
          upNum = val.upNum
        } else {
          up = val.isUp === 1 ? -1 : 1
          upNum = val.isUp === 1 ? val.upNum - 1 : val.upNum + 1 
        }
        this.articleList = this.articleList.map(item => {
          if (item.id === val.id) {
            item = Object.assign(item, { isUp: up, upNum })
          }
          return item
        })
      } else {
        this.fetchList()
      }
    },
    handleLinkTop(row) {
      const id = row.link.match(/\d+/g)
      this.$router.push({ name: 'articleDetail', params: { id: id[0] } })
    },
    handleSign: debounce(function() {
      if (this.userInfo.isCheckIn) {
        this.$router.push({ name: 'sign' })
        return
      }
      api.signIn().then(res => {
        this.updateUserInfo()
        if (res.code === 200) {
          this.$toast(
            {
              message: '签到成功',
              type: 'success',
            }
          )
          this.$router.push({ name: 'sign' })
        }
      })
    }, 1000)
  }
}
</script>
<style lang="less">
.toast-sub {
  width: initial;
}
</style>
<style lang="less" scoped>

.swipe-wrapper {
  display: flex;
  margin: 0 10px;
  padding: 2px 16px 2px 8px;
  height: 30px;
  background: #fff;
  border-radius: 4px;
  .swipe-top {
    line-height: 30px;
    font-size: 13px;
    margin-right: -10px;
    color: #FFB417;
    flex-shrink: 0;
  }
}
.swipe-out {
  margin-top: 10px;
}
.swipe-item {
  padding: 0 16px 0 16px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 280px;
  text-align: left;
}
.list-wrapper{
  padding-bottom: 24px; 
  /deep/ .van-pull-refresh {
    user-select: text;
    -webkit-user-select: text;
  }
  .bbs-tabs {
    top: 0!important;
    /deep/ .van-tab {
      max-width: 50%
    }
    /deep/ .van-popover__wrapper {
      width: 100%
    }
    .dept-name-wrap {
    display: flex;
    align-items: center;
    .dept-name {
      white-space: nowrap;
      flex: 1;
      overflow: hidden;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  }
  
  // /deep/ .van-tabs__nav {
  //   display: grid;
  //   grid-template-columns: 50% 50%;
  // }

}
  .dropdown-list {
    padding: 12px 16px;
    display: grid;
    // grid-template-columns: repeat(3, 1fr);
    // grid-column-gap: 24px;
    // grid-row-gap: 24px;
  }
    /deep/ .van-dropdown-menu {
        flex-shrink: 0;
        &[is-active="true"] {
          
          .van-dropdown-menu__title {
            color: #ee0a24;
          }
        }
      }
      /deep/ .van-dropdown-menu__bar {
        box-shadow: -5px 0 10px -5px rgba(100,101,102, 0.12);
      }
      /deep/ .van-dropdown-menu__title {
        // width: 36px;
        padding: 0 16px 0 12px;
        font-size: 14px;
        
        // height: 24px;
      }
      /deep/ .van-dropdown-menu__title::after {
        // left: 50%;
        right: 4px;
        border-color: transparent transparent #606266 #606266;
        // content: '';
        // width: 0;
        // height: 0;
        // border: 8px solid transparent;
        // border-top: 8px solid #dcdee0;
        // transform: translateX(-50%);
      }
  .dropdown-item {
    font-size: 14px;
    // background: #fbfbfb;
    color: #333333;
    border-radius: 8px;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    &[is-active='true'] {
      // background: #266bf6;
      color: #ee0a24;
      font-weight: bold;
    }
  }
.list-wrapper /deep/ .van-tab--active {
  font-size: 16px;
}
.list-wrapper /deep/ .van-icon-search {
  color: #909399;
}
.list-top {
  display: flex;
  align-items: center;
  background: #fff;
  padding-right: 12px;
}
.sign {
  display: flex;
  flex-direction: column;
  font-size: 10px;
  color: #4290f7;
  transform: scale(0.8);
}
.sub {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #fff;
  transform: scale(0.8);
  background: #4290f7;
  border-radius: 20px;
  padding: 4px 12px;
  &[issub='1'] {
    background: #fff;
    border: 1px solid #909399;
    padding: 4px 8px;
  }
}
.type-select-wrap {
  background: #fff;
  display: flex;
  align-items: center;
  padding: 8px 8px 8px 4px;
  justify-content: space-between;
}
.type-select-left {
  display: flex;
  align-items: center;
}
.type-item {
  font-size: 12px;
  background: #f8f8f8;
  padding: 6px 8px ;
  border-radius: 4px;
  margin: 0 8px;
  font-size: 13px;
  color: #8f8fa6;
  &[active="true"] {
    color: #333333;
  }
}
.type-operate {
  display: flex;
  img {
    // margin: 0 10px;
  }
  .operate-item {
    
    display: flex;
    margin: 0 6px;
    flex-direction: column;
    align-items: center;
    span {
      // padding-top: 2px;
      transform: scale(0.7);
      font-size: 12px;
    }
  }
}
.sub-badge {
  /deep/ .van-badge--fixed {
    transform: translate(50%, -50%) scale(0.7);
    left: 8px;
    right: initial;
  }
}
</style>
